<!-- ========================= header start ========================= -->
<header class="header bg-head navbar-area" #headerNavbar>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg">
                    <a class="navbar-brand" href="javascript:void(0)">
                        <img src="../../../assets/img/logo/logo.svg" alt="Logo" />
                    </a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                        <ul id="nav" class="navbar-nav ms-auto">
                            <li class="nav-item">
                                <a class="page-scroll active" href="https://www.sacombank.com.vn/canhan/Pages/default.aspx" data-bs-toggle="collapse" data-bs-target="#submenu-1-1" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">Cá nhân</a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" href="https://www.sacombank.com.vn/doanhnghiep/Pages/default.aspx">Doanh nghiệp</a>
                            </li>

                            <li class="nav-item">
                                <a class="page-scroll" href="https://www.sacombank.com.vn/Pages/default.aspx">Về SACOMBANK</a>
                            </li>
                        </ul>
                        <form action="#" class="search-form">
                            <a href="https://www.isacombank.com.vn/" class="btn-DigitalBank btn" style="text-transform: unset !important"><img src="../../../assets/img/ico-mobile.svg" alt="ico" /> Internet Banking</a>
                        </form>
                    </div>
                    <!-- navbar collapse -->
                </nav>
                <!-- navbar -->
            </div>
        </div>
        <!-- row -->
    </div>
    <!-- container -->
</header>
<!-- ========================= header end ========================= -->
<div class="component-block">
    <section class="block-formControlWrap">
        <div class="container">
            <div class="row">
                <div class="margin-bottom-5">
                    <div class="col-xs-6">
                        <div class="page-head">
                            <div class="page-title">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="block-formControl">
                        <div class="section-title-wrapper">
                            <span class="section-title">
                                Xác nhận email từ khách hàng
                            </span>
                        </div>
                        <div class="section">
                            <div class="text-center">
                                <img src="assets/img/email/notlink.png" style="width:20%;" />
                                <h3>Link không tồn tại</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="subscribe-section pt-15 pb-15 img-bg py-3">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6">
                <ul class="list-tab">
                    <li> <a href="https://www.sacombank.com.vn/canhan/Pages/default.aspx">Cá nhân</a> </li>
                    <li> <a class="active" href="https://www.sacombank.com.vn/doanhnghiep/Pages/default.aspx">Doanh nghiệp</a> </li>
                    <li> <a href="https://www.sacombank.com.vn/Pages/default.aspx">Về SACOMBANK</a> </li>
                </ul>
            </div>
            <div class="col-xl-6 col-lg-6">
                <ul class="list-text">
                    <li>Download app</li>
                    <li><img src="assets/img/android_app.png" alt="" /></li>
                    <li><img src="assets/img/apple_app.png" alt="" /></li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- ========================= subscribe-section end ========================= -->
<footer class="footer pt-0" *ngIf="!isMobile">
    <div class="container">
        <div class="copyright-area">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="footer-social-links">
                        <ul class="d-flex mb-0">
                            <li>
                                <a href="javascript:;"><i class="fa fa-facebook"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-google-plus"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-dribbble"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-linkedin"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-twitter"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-skype"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-github"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-youtube"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-dropbox"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <p class="copyright-text wow fadeInUp mb-0" data-wow-delay=".3s">©
                        <a href="https://www.sacombank.com.vn/" rel="nofollow">SACOMBANK</a> 2016 All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>